import { FiDocumentLayoutItem } from './layout-item';
import { FiDocumentLayoutItemTextViewComponent } from './layout-item-text-view/layout-item-text-view.component';
import { ViewChild, Directive, Input } from '@angular/core';
import { FiDocumentLayoutItemTextEditComponent } from './layout-item-text-edit/layout-item-text-edit.component';
import { TextEditorSelectionElementBuilderService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-selection-element-builder.service';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { isDefined } from '@fi-shared/utils';

@Directive()
export class FiDocumentLayoutItemTextBase extends FiDocumentLayoutItem {
    @ViewChild('col1', { static: false }) col1: FiDocumentLayoutItemTextViewComponent;
    @ViewChild('col2', { static: false }) col2: FiDocumentLayoutItemTextViewComponent;

    @ViewChild('editor1', { static: false }) editor1: FiDocumentLayoutItemTextEditComponent;
    @ViewChild('editor2', { static: false }) editor2: FiDocumentLayoutItemTextEditComponent;
    currentlyFocusedColumn: number;

    ngOnInit() {
        super.ngOnInit();
    }

    constructor(
        private textEditorSelectionElementBuilderService: TextEditorSelectionElementBuilderService,
        templateLayoutLanguageService: TemplateLayoutLanguageService,
    ) {
        super(templateLayoutLanguageService);
    }

    isEmpty(text: any) {
        return !(text && text.length > 0);
    }

    getCompareWithForColumn(colNumber): FiDocumentLayoutItemTextViewComponent {
        if (!this.compareWith || !this.compareWith.contentComponent) return;

        const inst = this.compareWith.contentComponent.instance;

        if (colNumber == 1) return inst.col1;

        if (colNumber == 2) return inst.col2;
    }

    onEditorFocus(column: number) {
        this.setNewFocusedColumn(column);
    }

    handleColumnClick(column: number, $event: MouseEvent) {
        if (column !== this.currentlyFocusedColumn) {
            this.setNewFocusedColumn(column);
        } else {
            if (($event.target as HTMLElement).classList.contains('column')) {
                $event.stopPropagation();
                $event.preventDefault();
            }
            const selection: Selection = window.getSelection();
            const currentRange = this.textEditorSelectionElementBuilderService.getCurrentRange();
            if (isDefined(currentRange) && selection.anchorOffset === selection.focusOffset) {
                selection.removeAllRanges();
                selection.addRange(currentRange);
            }
        }
    }

    setNewFocusedColumn(column: number) {
        if (column === 1 && this.editor1) {
            this.editor1.focusEditor();
        } else if (column === 2 && this.editor2) {
            this.editor2.focusEditor();
        }
        this.currentlyFocusedColumn = column;

        super.columnClick(column);
    }
}
